/* eslint-disable no-useless-escape */
import * as yup from "yup";

const phoneRegExp = /^0\d{9,10}$/;

const mobileRegExp = /^0\d{9,10}$/;

const numbersOnly = /^[0-9]*$/;

// const Links =
//   /(http|ftp|https):\/\/([\w_-]+(?:(?:\.[\w_-]+)+))([\w.,@?^=%&:\/~+#-]*[\w@?^=%&\/~+#-])/;

export const ForgetPasswordSchema = yup.object().shape({
  email: yup.string().email().required("Email is a required field"),
});

export const AuthSchema = yup.object().shape({
  Email: yup.string().email().required("Email is a required field"),
  password: yup.string().required("password is not valid"),
});

export const EmployeeInfoSchema = yup.object().shape({
  EmployeeName: yup
    .string()
    .trim("please enter real date here")
    .matches(/^[aA-zZ\s]+$/, "Only alphabets are allowed for this field ")
    .required("Employee Name is required"),
  EmployeeCode: yup.string().required("Employee code is required"),
  PhoneNumber: yup
    .string()
    .matches(phoneRegExp, "Employee phone is not valid")
    .min(11)
    .max(11)
    .required(),
  MobileNumber: yup
    .string()
    .matches(mobileRegExp, "Employee Mobile is not valid")
    .min(11)
    .max(11)
    .required(),
  EmployeeDriveLicenseNumber: yup.string().matches(numbersOnly, "Numbers only"),
  EmployeeEmail: yup.string().email(),
  EmployeeNationalID: yup.string().required(),
  Education: yup.string(),
  EmployeeNote: yup.string(),
  EmployeeDateOfBirth: yup.string().required(),
  EmployeeLeaveDate: yup.string().required(),
  EmployeeStartDate: yup.string().required(),
  EmployeeCountry: yup.string().required(),
  EmployeeCity: yup.string().required(),
  EmployeePosition: yup.string().required(),
  EmployeeMaritalStatus: yup.string().required(),
  EmployeeMilitaryStatus: yup.string().required(),
  EmployeeWorkArea: yup.string().required(),
  EmployeeEducation: yup.string().required(),
  EmployeeStatus: yup.string().required(),
});

export const createCustomerBranch = yup.object().shape({
  BranchName: yup.string().trim().required("Branch Name is required"),
  BranchLocation: yup.string().required("Branch Location is required"),
  BranchAddress: yup.string().required("Branch Address is required"),
  BranchLandmark: yup.string().required("Branch landmark is required"),
  BranchGBS: yup.string(),
});
// .matches(Links, "Invalid URL"),
export const createCustomerContact = yup.object().shape({
  Name: yup.string().trim().required("Name is required"),
  Title: yup.string().trim().required("Title is required"),
  Mobile: yup.string().matches(numbersOnly, "Numbers only").required(),
  Email: yup.string().email(),
  Note: yup.string(),
});

export const CreateComercialCustomersSchema = yup.object().shape({
  CustomerName: yup.string().trim().required("customer Name is required"),
  CustomerCode: yup.string().required("Customer code is required"),
  CommercialName: yup.string().trim().required("Commercial Name is required"),
  // eslint-disable-next-line prettier/prettier
  CommercialRegistrationnmber: yup
    .string()
    .required("Commercial Registeration number code is required"),
  TAXNumber: yup.string().required("TAXNumber is required"),
  CustomerEmail: yup.string().email(),
  CommercialLandmark: yup.string(),
  CommericalAddress: yup.string(),
});
export const CreateindividualCustomersSchema = yup.object().shape({
  CustomerName: yup.string().trim().required("customer Name is required"),
  CustomerEmail: yup.string().email().required("customer E-mail is required"),
  CustomerHQAddress: yup.string().trim().required("customer HQ address is required"),
  CustomerMobileNumber: yup.string().matches(numbersOnly, "Numbers only").required(),
  CustomerHQCountry: yup.string().trim().required("customer HQ Country is required"),
  CustomerHQCity: yup.string().trim().required("customer HQ City is required"),
  CustomerAccountType: yup.string().trim().required("customer Account Type is required"),
  CustomerBuildingType: yup.string().trim().required("customer Building Type is required"),
  CustomerSalesEmployee: yup.string().trim().required("customer Sales Employee is required"),
});

export const CreateindividualCustomersContractSchema = yup.object().shape({
  ContractStartDate: yup.string().required(),
  ContractEndDate: yup.string().required(),
  ContractTotalNoOfVisits: yup.string().matches(numbersOnly, "Numbers only"),
  ContractTotalcoveredbranches: yup.string().matches(numbersOnly, "Numbers only"),
  ContractVisitNumberPerType: yup.string().matches(numbersOnly, "Numbers only"),
  ContractVisitsType: yup.string().required(),
  ContractTotalContractAmount: yup.string().matches(numbersOnly, "Numbers only"),
  ContractStatus: yup.string().required(),
  ContractPaymentType: yup.string().required(),
  Comments: yup.string(),
});

export const CreateComercialContractSchema = yup.object().shape({
  ContractStartDate: yup.string().required(),
  ContractEndDate: yup.string().required(),
  // Branches: yup.number().required(),
  // ContractCoverageList: yup.string().required(),
  ContractStatus: yup.string().required(),
  ContractPaymentType: yup.string().required(),
  ContractCoveragePestsNote: yup.string().trim(),
  ContractTotalContractAmount: yup
    .string()
    .matches(numbersOnly, "Numbers only")
    .required("Contract amount is required"),
  Month1: yup.string().matches(numbersOnly, "Numbers only"),
  Month2: yup.string().matches(numbersOnly, "Numbers only"),
  Month3: yup.string().matches(numbersOnly, "Numbers only"),
  Month4: yup.string().matches(numbersOnly, "Numbers only"),
  Month5: yup.string().matches(numbersOnly, "Numbers only"),
  Month6: yup.string().matches(numbersOnly, "Numbers only"),
  Month7: yup.string().matches(numbersOnly, "Numbers only"),
  Month8: yup.string().matches(numbersOnly, "Numbers only"),
  Month9: yup.string().matches(numbersOnly, "Numbers only"),
  Month10: yup.string().matches(numbersOnly, "Numbers only"),
  Month11: yup.string().matches(numbersOnly, "Numbers only"),
  Month12: yup.string().matches(numbersOnly, "Numbers only"),
});

export const CustomerReSchema = yup.object().shape({
  CustomerReName: yup.string().required(),
  CustomerReMail: yup.string().email().required(),
  CustomerReTitle: yup.string().required(),
  CustomerRePosition: yup.string().required(),
  CustomerRePhone: yup.string().matches(numbersOnly, "Numbers only").required(),
});

export const EmployeeCreateWebAccountSchema = yup.object().shape({
  EmployeeActiveEmail: yup.string().email(),
  EmployeePassword: yup.string(),
  EmployeePasswordConfirmation: yup
    .string()
    .oneOf([yup.ref("EmployeePassword")], "password confirmation doesn't match password"),
});

export const EmployeeCreateMobileAccountSchema = yup.object().shape({
  ActiveMobileNumber: yup.string().matches(phoneRegExp, "Numbers only").min(11),
  PINCode: yup.string().matches(numbersOnly, "Numbers only").required(),
});

export const EmployeeAddAttachmentSchema = yup.object().shape({
  FileName: yup.string(),
  ImageType: yup.string(),
  FileNotes: yup.string(),
});

export const SearchEmployeesSchema = yup.object().shape({
  EmployeeName: yup.string(),
  EmployeeMobile: yup.string(),
  EmployeeEmail: yup.string().email(),
  EmployeeNationalID: yup.string(),
});

export const SearchComercialCustomerSchema = yup.object().shape({
  CustomerName: yup.string(),
  CustomerCode: yup.string(),
  CustomerEmail: yup.string().email(),
  AccountType: yup.string(),
  BusinessType: yup.string(),
});

export const SearchIndividualCustomerSchema = yup.object().shape({
  CustomerName: yup.string(),
  CustomerMobileNumber: yup.string(),
  CustomerEmail: yup.string().email(),
});

export const SearchVehicleSchema = yup.object().shape({
  VehicleVINNumber: yup.string(),
  VehiclePlateNumber: yup.string(),
  VehicleModel: yup.string(),
});

export const CreateVehicleSchema = yup.object().shape({
  VehicleCode: yup.string().required("Vehicle Code ia a required field"),
  VehicleVINNumber: yup.string().matches(numbersOnly, "Numbers only").required(),
  VehiclePlateNumber: yup.string().required("Plate Number Required"),
  VehicleModel: yup.string().required("Vehicle Model is required"),
  VehicleColor: yup.string().required("Vehicle Color is required"),
  VehicleBodyNumber: yup.string().matches(numbersOnly, "Numbers only").required(),
  VehicleMotorNumber: yup.string().matches(numbersOnly, "Numbers only").required(),
  VehicleYear: yup.string().matches(numbersOnly, "Numbers only").required(),
  VehicleStartMileAge: yup.string().matches(numbersOnly, "Numbers only").required(),
  VehicleInsuranceCompany: yup.string().required("Vehicle insurance company is required"),
  VehicleInsuranceCoverageDetails: yup.string(),
  VehicleInsuranceExpireDate: yup.string().required("Vehicle insurance expire date is required"),
  VehicleInsuranceIssueDate: yup.string().required("Vehicle insurance issue date is required"),
  VehicleLicenseExpireDate: yup.string().required("Vehicle license expire date is required"),
  VehicleLicenseIssueDate: yup.string().required("Vehicle license issue date is required"),
});

export const CreateSingleTaskSchema = yup.object().shape({
  CustomerName: yup.string().required("Customer Name is required"),
  ContractID: yup.string().required("Contract is required"),
  BranchName: yup.string().required("Branchs is required"),
  VisitNumber: yup.string().required("visit number is required"),
  Year: yup.string().required("Year is required"),
  Month: yup.string().required("Month is required"),
  hour: yup.string().matches(numbersOnly, "Numbers only").required(),
  minute: yup.string().matches(numbersOnly, "Numbers only").required(),
  AmPm: yup.string().required("AM / PM is required"),
  Day: yup.string().required("Day is required"),
  CollectMoney: yup.string().matches(numbersOnly, "Numbers only"),
  TaskNote: yup.string(),
});

export const CreateIndividualTaskSchema = yup.object().shape({
  CustomerNameIndividual: yup.string().required("Customer Name is required"),
  ContractIDIndividual: yup.string(),
  VisitNumberIndividual: yup.string().required("visit number is required"),
  YearIndividual: yup.string().required("Year is required"),
  MonthIndividual: yup.string().required("Month is required"),
  hourIndividual: yup.string().matches(numbersOnly, "Numbers only").required(),
  minuteIndividual: yup.string().matches(numbersOnly, "Numbers only").required(),
  AmPmIndividual: yup.string().required("AM / PM is required"),
  DayIndividual: yup.string().required("Day is required"),
  CollectMoneyIndividual: yup.string().matches(numbersOnly, "Numbers only"),
  TaskNoteIndividual: yup.string(),
});

export const TaskSchema = yup.object().shape({
  CustomerName: yup.string(),
  BranchName: yup.string(),
  hour: yup.string().matches(numbersOnly, "Numbers only").required(),
  minute: yup.string().matches(numbersOnly, "Numbers only").required(),
  AmPm: yup.string().required("AM / PM is required"),
  Day: yup.string().required("Day is required"),
  CollectMoney: yup.string().matches(numbersOnly, "Numbers only"),
  TaskNote: yup.string(),
});

export const ComplaintsSchema = yup.object().shape({
  Month: yup.string().required("Month number is required"),
  Year: yup.string().required("Year number is required"),
});

export const EditComplaintsSchema = yup.object().shape({
  ComplaintStatus: yup.string(),
  ComplaintDetails: yup.string(),
});

export const ConfiguartionSchema = yup.object().shape({
  ConfigValue: yup.string().required("Value is required"),
  ConfigName: yup.string(),
});

export const SearchCustomerSchema = yup.object().shape({
  CustomerName: yup.string(),
  Year: yup.string(),
  month: yup.string(),
  code: yup.string().matches(numbersOnly, "Numbers only"),
});

export const monthlyGenerateSchema = yup.object().shape({
  CustomerName: yup.string(),
  month: yup.string(),
});

export const HandlingCoverageSchema = yup.object().shape({
  Material: yup.string().required(),
});

export const customerRepresentiveSchema = yup.object().shape({
  CustomerReName: yup.string().required(),
  CustomerRePosition: yup.string().required(),
  CustomerReMail: yup.string().email().required(),
  CustomerRePhone: yup.string().matches(numbersOnly, "Numbers only").required(),
  CustomerReTitle: yup.string().required(),
});
